import { render, staticRenderFns } from "./visa.vue?vue&type=template&id=2b97d413&scoped=true&"
import script from "./visa.vue?vue&type=script&lang=js&"
export * from "./visa.vue?vue&type=script&lang=js&"
import style0 from "./visa.vue?vue&type=style&index=0&id=2b97d413&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b97d413",
  null
  
)

export default component.exports